import { Product } from './catalog/ProductPage/GetProduct.query'

export default (product: Product) => ({
    type: product.itemLabelTypeB2CValues?.[0]?.label || product.labeltype,
    text: product.itemLabelTextB2CValues?.[0]?.label || product.labeltekst,
})
